

















import { Prop, Component } from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class ZoomImageDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private src!: string
  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  @Prop() private open!: boolean

  get zoomImageDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
          color: 'white',
        },
      },
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
